import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Connectors } from '../types';

type InitialState = {
  isLoading: boolean;
  connectors: Connectors | null;
  error: any;
  isCreateConnectorLoading: boolean;
  isUpdatedConnectorLoading: boolean;
  isCreateConnectorErrors: any;
  isUpdatedConnectorErrors: any;
};

const initialState: InitialState = {
  isLoading: false,
  connectors: null,
  error: null,
  isCreateConnectorLoading: false,
  isUpdatedConnectorLoading: false,
  isCreateConnectorErrors: null,
  isUpdatedConnectorErrors: null,
};

const connectors = createSlice({
  name: 'connectors',
  initialState,
  reducers: {
    requestConnectors: (state) => {
      state.isLoading = true;
    },
    getConnectorsSuccess: (state, { payload }: PayloadAction<Connectors>): void => {
      state.isLoading = false;
      state.connectors = payload;
    },
    getConnectorsError: (state, { payload }: PayloadAction<string>): void => {
      state.isLoading = false;
      state.error = payload;
    },
    requestCreateConnector: (state, { payload }) => {
      state.isCreateConnectorLoading = true;
    },
    getCreateConnectorSuccess: (state, { payload }) => {
      state.isCreateConnectorLoading = false;
    },
    getCreateConnectorError: (state, { payload }) => {
      state.isCreateConnectorLoading = false;
      state.isCreateConnectorErrors = payload;
    },
    requestUpdateConnector: (state, { payload }) => {
      state.isUpdatedConnectorLoading = true;
    },
    getUpdateConnectorSuccess: (state, { payload }) => {
      state.isUpdatedConnectorLoading = false;
    },
    getUpdateConnectorError: (state, { payload }) => {
      state.isUpdatedConnectorLoading = false;
      state.isUpdatedConnectorErrors = payload;
    },
    clearConnectors: (state): void => {
      state.connectors = null;
    },
  },
});

export const {
  requestConnectors,
  getConnectorsSuccess,
  getConnectorsError,
  clearConnectors,
  requestCreateConnector,
  getCreateConnectorSuccess,
  getCreateConnectorError,
  requestUpdateConnector,
  getUpdateConnectorSuccess,
  getUpdateConnectorError,
} = connectors.actions;

export default connectors.reducer;
